import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import GiftReport from "./GiftReport/GiftReport";
import AllReports from "./AllReports/AllReports";
import RedeemReport from "./RedeemReport/RedeemReport";
import RewardsReport from "./RewardsReport/RewardsReport";
import { fetchAllTransactionReport } from "../../../../store/actions/report/ReportsAction";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import { convertToISTDateTime, convertToISTDate } from "../../../../utils/DateTime.service";
import { clearOfflineGoldPurchase } from "../../../../store/actions/report/ReportsAction";

const TransactionsReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("AllTransactions");
  const [currentPage, setCurrentPage] = useState(1);
  const [transactionType, setTransactionType] = useState("all"); // all, gifting, redeem, rewards
  const [startDate, setStartDate] = useState(moment().subtract(7, "days"));
  const [endDate, setEndDate] = useState(moment());
  const itemsPerPage = Number(process.env.REACT_APP_ITEMS_PER_PAGE);

  const { loading, error, transactions, totalCount } = useSelector((state) => state.transactionReport);

  const tabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    switch (tab) {
      case "AllTransactions":
        setTransactionType("all");
        setStartDate(moment().subtract(7, "days"));
        setEndDate(moment());
        break;
      case "Gift":
        setTransactionType("gifting");
        setStartDate(moment().subtract(7, "days"));
        setEndDate(moment());
        break;
      case "Redeem":
        setTransactionType("redeem");
        setStartDate(moment().subtract(7, "days"));
        setEndDate(moment());
        break;
      case "Rewards":
        setTransactionType("reward");
        setStartDate(moment().subtract(7, "days"));
        setEndDate(moment());
        break;
      default:
        setTransactionType("all");
        setStartDate(moment().subtract(7, "days"));
        setEndDate(moment());
        break;
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [activeTab, dispatch]);

  const fetchTransactions = () => {
    const payload = {
      // start_date: startDate.format("YYYY-MM-DD"),
      // end_date: endDate.format("YYYY-MM-DD"),
      start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
      transaction_type: transactionType, // all, gifting, redeem, reward
    };
    dispatch(fetchAllTransactionReport(payload, navigate));
  };

  const handlePageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, prevPage + increment));
  };

  const totalPages = transactions && Math.ceil(transactions.length / itemsPerPage);

  const defaultOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored",
  };

  const handleGo = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.", defaultOptions);
      return;
    }

    const payload = {
      start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
      end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
      transaction_type: transactionType,
    };
    dispatch(fetchAllTransactionReport(payload, navigate));
  };

  const onFormReset = () => {
    // const newStartDate = moment().subtract(7, "days");
    // const newEndDate = moment();
    // setStartDate(newStartDate);
    // setEndDate(newEndDate);
    // setCurrentPage(1);
    // const payload = {
    //   start_date: newStartDate.format("YYYY-MM-DD"),
    //   end_date: newEndDate.format("YYYY-MM-DD"),
    // };
    // dispatch(fetchAllTransactionReport(payload, navigate));
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);

    dispatch(clearOfflineGoldPurchase());
  };

  // const onPageChange = (increment) => {
  //   setCurrentPage((prevPage) => Math.max(1, Math.min(prevPage + increment, totalPages)));
  // };
  const handleDownload = () => {
    if (transactions.length === 0) {
      toast.info("No data available for download!", defaultOptions);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      transactions.map((item) => ({
        CreatedAt: `${convertToISTDateTime(item.created_at)}` || "--",
        CustomerID: item.customer_id || "--",
        GoldQuantity: `${item.gold_quantity} gm` || "--",
        Phone: item.phone || "--",
        PricePerGram: `₹ ${item.price_per_gram}` || "--",
        ReceiverID: item.receiver_id || "--",
        Remarks: item.remarks || "--",
        RewardPoints: `${item.reward_points} gm` || "--",
        Status: item.status || "--",
        TotalAmount: `₹ ${item.total_amount}` || "--",
        TransactionDate: item.transaction_date ? convertToISTDateTime(item.transaction_date) : "--",
        TransactionID: item.transaction_id || "--",
        TransactionType: item.transaction_type || "--",
        UpdatedAt: `${convertToISTDateTime(item.updated_at)}` || "--",
      }))
    );

    const workbook = XLSX.utils.book_new();
    const sheetName = "Report";
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, `${transactionType}_Report_${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  const currentItems = transactions && transactions.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Transactions</Link>
          </li>
          {/* <li className='breadcrumb-item'>
            <Link to={"#"}>All Transactions</Link>
          </li> */}
        </ol>
      </div>

      <div className='row '>
        <div className='col-lg-12'>
          <div className='card'>
            <Tab.Container activeKey={activeTab} onSelect={tabChange}>
              <div className='d-flex justify-content-between align-items-center border-end px-3 py-2'>
                <Nav as='ul' className='nav nav-tabs px-1' style={{ alignSelf: "flex-end" }}>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='AllTransactions'>All</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Gift'>Gift</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Redeem'>Redeem</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Rewards'>Rewards</Nav.Link>
                  </Nav.Item>
                </Nav>

                <div className='d-flex align-items-center justify-content-end'>
                  <div className='d-flex flex-column  mx-1 w-25'>
                    <div className='ms-2'>From:</div>
                    {/* <DatePicker  selected={startDate.toDate()} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate.toDate()} /> */}
                    <DatePicker selected={startDate ? startDate.toDate() : null} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate ? endDate.toDate() : null} onKeyDown={(e) => e.preventDefault()} />
                  </div>
                  <div className='d-flex flex-column mx-1 w-25'>
                    <div className='ms-2'>To:</div>
                    {/* <DatePicker selected={endDate.toDate()} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate.toDate()} maxDate={moment().toDate()} /> */}
                    <DatePicker selected={endDate ? endDate.toDate() : null} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate ? startDate.toDate() : null} maxDate={moment().toDate()} onKeyDown={(e) => e.preventDefault()} />
                  </div>
                  <div className="'d-flex mt-3">
                    <button className='btn btn-primary mx-1' type='button' onClick={handleGo}>
                      Go
                    </button>
                    <button className='btn btn btn-outline-secondary mx-1' type='button' onClick={onFormReset}>
                      Clear
                    </button>
                    <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
                      Download
                    </button>
                  </div>
                </div>
              </div>

              <Tab.Content>
                <Tab.Pane eventKey='AllTransactions'>
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <AllReports transactions={currentItems} loading={loading} />}
                  {!loading && currentItems.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Gift'>
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <GiftReport transactions={currentItems} loading={loading} />}
                  {!loading && currentItems.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Redeem'>
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <RedeemReport transactions={currentItems} loading={loading} />}
                  {!loading && currentItems.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Rewards'>
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <RewardsReport transactions={currentItems} loading={loading} />}
                  {!loading && currentItems.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </>
  );
};

const Pagination = ({ currentPage, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / 10);

  return (
    <>
      <div className='d-flex justify-content-end align-items-center px-4 py-2'>
        <div className='d-sm-flex justify-content-end align-items-center ms-3 mt-3 mb-3'>
          <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center' id='example2_paginate'>
            <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => currentPage > 1 && onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
            <span className='mx-2'>
              Page {currentPage} of {totalPages}
            </span>
            <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => currentPage < totalPages && onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionsReport;
